import React, { useEffect } from 'react'
import useWebSocket from 'react-use-websocket'
import { TypeOptions } from 'react-toastify'
import { UnreadNotificationsCountResponse } from 'services/types'

export type WebsocketToastMessage = {
  type: 'toast'
  data: {
    type: TypeOptions
    title: string
    description: string
    export_id?: string
    link: {
      label: string
      value: string
      target: '_blank'
    }
  }
}

export type WebsocketResultModalMessage = {
  type: 'result-modal'
  data: {
    title: string
    success_message?: string
    failure_message?: string
    success_list: Array<{ value: string; message: string }>
    failure_list: Array<{ value: string; reason: string }>
  }
}

// manage order settings socket message
export type WebsocketBulkActionToastMessage = {
  type: 'bulk_action_toast'
  data: {
    title: string
    description: string
    success_list: Array<{ id: string | number; name: string }>
    failure_list: Array<{ id: string | number; name: string; type: string }>
    type: TypeOptions
    model: 'entity' | 'service_point' | 'ops_service_point'
  }
}

export type WebsocketCreatedObjectDetailsToastMessage = {
  type: 'created_object_details_toast'
  data: {
    title: string
    details: Array<{ label: string; value: string | number; type: string }>
    type: TypeOptions
    link: {
      label: string
      value: string
      target: '_blank'
    }
    model: 'order' | 'case'
    creator_id?: string
  }
}

export type WebsocketUnreadNotificationsCountMessage = {
  type: 'unread_notifications_counts'
} & UnreadNotificationsCountResponse

export type WebsocketMessage =
  | WebsocketToastMessage
  | WebsocketResultModalMessage
  | WebsocketBulkActionToastMessage
  | WebsocketCreatedObjectDetailsToastMessage
  | WebsocketUnreadNotificationsCountMessage

type WebsocketConsumerProps = {
  url: string
  onMessage: (message: WebsocketMessage) => void
}

export const WebsocketConsumer: React.FC<React.PropsWithChildren<WebsocketConsumerProps>> = ({
  url,
  onMessage,
  children,
}) => {
  const { lastJsonMessage } = useWebSocket(url)
  useEffect(() => {
    if (lastJsonMessage) {
      onMessage(lastJsonMessage as any)
    }
  }, [lastJsonMessage, onMessage])

  return children
}
